export const FIRESTORE_BATCH_SIZE = 500;
export const MAX_CONCURRENT_STUDENT_DELETES = 100;
